import { useCanvasFloatingChat } from "../context/CanvasFloatingChatContext";
import { useCanvasWidth } from "./useCanvasWidth";

/**
 * Toolbar layout from the outer React Flow wrapper width (`reactFlowWrapperEl` in
 * `CanvasUiContext`, set by `CanvasPageInner` ref callback).
 * `topControlsRightClearancePx` and `bottomToolbarRightClearancePx` are measured
 * in `CanvasFloatingChatPanel` from the chat shell geometry.
 */
export function useCanvasWrapperLayout() {
  const canvasWrapperWidth = useCanvasWidth();
  const { bottomToolbarRightClearancePx, topControlsRightClearancePx } =
    useCanvasFloatingChat();

  const controlsMaxWidth =
    canvasWrapperWidth === 0
      ? 0
      : Math.max(0, canvasWrapperWidth - bottomToolbarRightClearancePx);

  return {
    canvasWrapperWidth,
    controlsMaxWidth,
    controlsRightOffset: topControlsRightClearancePx,
  };
}
